export default __webpack_public_path__ + "static/media/Vijajayawada.df6b8dc1.webp";